// noUncheckedIndexedAccess types even a provably-in-range read as T | undefined. This is the one
// sanctioned place that gap is closed, and it throws rather than letting the undefined travel on.
export function itemAt<T>(items: readonly T[], index: number): T {
  const item = items[index]
  if (item === undefined) throw new RangeError(`index ${index} is outside an array of ${items.length}`)
  return item
}

export function moveItem<T>(items: T[], from: number, to: number): T[] {
  const moved = items[from]
  if (moved === undefined) return [...items]

  const next = [...items]
  next.splice(from, 1)
  next.splice(to, 0, moved)
  return next
}
